import React from "react";

const Title = ({ useH1, children }) => {
    if (useH1) return <h1>{children}</h1>;
    return <h2>{children}</h2>;
};

export default Title;
